import React from 'react'
import { NewsSessionBoundary } from './features/News/hooks/useNews'
import { ToastContainer } from 'react-toastify'
import AppRoutes from './routes/AppRoutes'
import { AuthProvider } from './contexts/AuthContext'
import 'react-toastify/dist/ReactToastify.css'
import { toastConfig } from './config/toastify.config'

const App: React.FC = () => {
  return (
    <>
      <ToastContainer {...toastConfig} />
      <AuthProvider>
        <NewsSessionBoundary />
        <AppRoutes />
      </AuthProvider>
    </>
  )
}

export default App
